import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ADDRESS_FIELDS } from '../../../constants/serverFieldMappings';
import FormField from './FormField';
import {
  BUSINESS_INFO_GOOGLE_AUTOCOMPLETE,
  OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE
} from '../../../constants/googleAPI';

class FormFields extends Component {
  constructor() {
    super();

    this.state = {
      currentSectionFields: [],
      ownerToRemove: null
    };
  }

  componentDidMount() {
    this.getSectionFields();
  }

  componentDidUpdate({sectionKey: prevSectionKey}){
    if (prevSectionKey !== this.props.sectionKey) {
      this.getSectionFields();
    }
  }

  getSectionFields() {
    const { fields, sectionKey } = this.props;
    if (Object.keys(fields).length > 0 && sectionKey) {
      this.setState({
        currentSectionFields: fields[sectionKey]
      });
    }
  }

  hasMinNumberOfOwners(submission, min) {
    return submission.owners && submission.owners.length > min;
  }

  isSection(index) {
    const { sectionKey } = this.props;

    return sectionKey === `section${index}`;
  }

  mergeSection2WithOwners() {
    const { fields, submission } = this.props;
    if (this.isSection(2) && this.hasMinNumberOfOwners(submission, 0)) {

      let additionalFields = submission.owners.map((owner, index) => 
        fields['ownerInfo'](index)
      );

      // flatten array of arrays
      additionalFields = additionalFields.reduce((acc, owner) => [...acc, ...owner], []);

      if (submission.owners.length < 4) {
        additionalFields = [
          ...additionalFields,
          fields['addOwnerButton']
        ];
      }

      return additionalFields;
    }
    return [];
  }

  removeOwner(id) {
    this.props.submissionInfoActions.removeOwner(id, this.props.submission);
    this.setState({ownerToRemove: null});
  }

  closeButtonAction(id) {
    this.setState({ownerToRemove: id});
  }

  cancelRemoveOwner() {
    this.setState({ownerToRemove: null});
  }

  mergeBaseAndConditionalFields() {
    const {currentSectionFields} = this.state;
    return [
      ...currentSectionFields,
      ...this.mergeSection2WithOwners()
    ];
  }

  isFieldPartOfAddress({modelVal}) {
    const { STREET_1, STREET_2, CITY, STATE, ZIP } = ADDRESS_FIELDS;

    return [STREET_1, STREET_2, CITY, STATE, ZIP].includes(modelVal);
  }

  /**
   * used by GoogleAddressSearch in FormField
   * @param {Object} field
   */
  onSelect(field) {
    if (this.props.google_place_id && this.isFieldPartOfAddress(field)) {
      return () => this.props.addressActions.resetGoogleSpecifics();
    } else if (field.modelVal === BUSINESS_INFO_GOOGLE_AUTOCOMPLETE.MODEL) {
      return (googleResponse) => {
        this.props.accountDetailsActions.setAccountDetails(googleResponse);
        this.props.addressActions.setAccountAddress(googleResponse);
      };
    } else if (typeof field.modelVal === 'string' && field.modelVal.includes(OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE.MODEL)) {
      return (googleResponse) => {
        this.props.addressActions.setOwnerAddress(field.ownerIndex, googleResponse);
      };
    }
  }

  render() {
    const sectionFields = this.mergeBaseAndConditionalFields();

    const {
      submissionInfo: { form: { files } },
      uploadInstructions
    } = this.props;
    // get all props except className as filteredProps
    /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
    const {className, ...filteredProps} = this.props;
    return sectionFields.map((field, index) => {
      // lazy evaluation is the process of returning a function
      // due to this the below functions must be bound

      return (
        <FormField
          key={`${field.modelVal}${index}`}
          {...filteredProps}
          modelName="submission"
          field={field}
          filesToBeUploaded={files}
          onSelect={this.onSelect(field)}
          uploadInstructions={uploadInstructions}
          addOwner={this.props.submissionInfoActions.addOwner.bind(this)}
          closeButtonAction={(this.isSection(2) && this.hasMinNumberOfOwners(this.props.submission, 1)) ? this.closeButtonAction.bind(this) : null}
          removeOwner={this.removeOwner.bind(this)}
          ownerToRemove={this.state.ownerToRemove}
          cancelRemoveOwner={this.cancelRemoveOwner.bind(this)}
        />
      );
    });
  }
}

FormFields.propTypes = {
  accountDetailsActions: PropTypes.object,
  addressActions: PropTypes.object,
  className: PropTypes.string,
  failedUploads: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  google_place_id: PropTypes.string,
  sectionKey: PropTypes.string,
  submission: PropTypes.object,
  submissionInfo: PropTypes.object.isRequired,
  submissionInfoActions: PropTypes.object.isRequired,
  totalSections: PropTypes.number.isRequired,
  uploadInstructions: PropTypes.object
};

FormFields.defaultProps = {
  submission: {}
};

export default FormFields;
